module.exports = __webpack_public_path__ + "img/parceiro7.e38c42fb.png";